export const DEFAULT_UI_DICTIONARY = {
    Communication: "Communication",
    Matter: "Matter",
    Tags: "Tags",
    Timekeepingalert: "TimeSlip",
    Timekeeping: "Timeslip", 
    Duration: "Duration",
    Timekeeper: "Timekeeper",
    ActivityCode: "Activity Code", 
    TaskCode: "Task Code",
    Description: "Description",
    Note: "Note",
    ClarraDocs: "ClarraDocs",
    Status: "Status",
    MailTypes: "Service Type",
    Attachment: "Attachment",
    Docketing: "Docketing"
} as const;

export const API_NAME_TO_UI_KEY_MAP= {
    "Matter": "Matter",         
    "Timekeeping": "Timekeeping",
    "Timekeepingalert": "Timekeepingalert",
    "Duration": "Duration",
    "Timekeeper": "Timekeeper",  
    "Activity Code": "ActivityCode", 
    "Task Code": "TaskCode",         
    "Description": "Description",
    "Note": "Note",
    "ClarraDocs": "ClarraDocs",
    "Status": "Status",
    "MailTypes": "MailTypes",    
    "Attachment": "Attachment",
    "Docketing": "Docketing"
} as const;


export const BACKEND_ERROR_MAP: Record<string, string> = {
    "Timeslip": "Timekeeping",
    "Service Type": "MailTypes",
    "Activity Code": "ActivityCode",
    "Task Code": "TaskCode"
};

export const LOCALSTORAGE_KEYS = {
    "Attachments": "attachments",
    "ItemDate": "ItemDate",
    "SelectedCC": "SelectedCc",
    "SelectedTO": "SelectedTo",
    "SelectedTags" : "SelectedTags",
    "SelectedMatter" : "SelectedMatter",
    "SelectedMatterID" : "SelectedMatterID",
    "AccessToken" : "AccessToken",
    "AuthToken" : "authToken",
    "AuthToken1" :"authToken1",
    "LoggedUsers" : "loggedUsers",
    "LoggedProfile" : "loggedProfile",
    "apibaseurl":"API_BASE_URL",
    "SelectedMatterDoc":"SelectedMatterDoc",
    "SelectedMatterIDDoc" : "SelectedMatterIDDoc",
    "SelectedMatterIDTS" : "SelectedMatterIDTS",
    "SelectedTagsDoc":"SelectedTagsDoc",
    "TimeSlipSetting":"TimeSlipSetting",
    "currentSendingItem":"currentSendingItem",
    "onSendResponse":"onSendResponse",
    "formData":"formData",
    "hostName":"hostName",
    "isClassicOutlook":"isClassicOutlook",
    "isMacOutlook":"isMacOutlook",
    "mode":"mode",
    "EmailAPIObject":"EmailAPIObject",
    "BACKEND_ERROR_MAP":"BACKEND_ERROR_MAP",
    "IngnoreFileExtensions" : "IngnoreFileExtensions",
    "UploadURL" : "UploadURL",

} as const;

